import { Box, Button, Typography } from "@mui/material";
import Grid from '@mui/material/Grid2';
import OktaAuth from "@okta/okta-auth-js";
import { useNavigate } from "react-router-dom";
import { oktaConfig, oktaExternalConfig } from "../../common/okta/Okta.Config";
import { setIsInternalUser } from "../../store/OktaAuthSlice";
import { persistor, useAppDispatch } from "../../store/store";
import pepsicoLogo from "./../../assets/svgs/pepsiLogoHome.svg";
import styles from "./LoginComponent.module.css";


const buttonStyle = { backgroundColor: '#0047ba', marginTop: '20px', fontSize: '14px', width: '70%' };


const oktaAuth = new OktaAuth(oktaConfig);

const oktaAuthExt = new OktaAuth(oktaExternalConfig);

const LoginComponent = () => {

    const navigate = useNavigate();

    const dispatch = useAppDispatch();

    const clearStore = async () => {
        persistor.purge();
    }

    const handleSSOSignIn = () => {
        clearStore();
        dispatch(setIsInternalUser(true));
        oktaAuth.signInWithRedirect({ originalUri: "/dashboard" });
    }

    const handleSSOExtSignIn = () => {
        clearStore();
        dispatch(setIsInternalUser(false));
        oktaAuthExt.signInWithRedirect({ originalUri: "/dashboard" });
    }

    const handleRegistrationClick = () => {
        navigate("/register")
    }

    return (
        <div className="backgroundImgHome">
            <Grid container className={styles.loginAppContainer}>
                <Grid size={{ xs: 2, sm: 3, md: 4, lg: 4, xl: 4.5 }}></Grid>
                <Grid size={{ xs: 8, sm: 6, md: 4, lg: 4, xl: 3 }}>
                    <Box className={styles.loginBoxContainer}>
                        <form onSubmit={(event: React.FormEvent<HTMLFormElement>) => {
                            event.preventDefault();
                        }}>
                            <Grid container className={styles.loginForm} >
                                <Grid size={{ xs: 12, sm: 12 }} textAlign="center">
                                    <span className={styles.imageLogo}>
                                        <img src={pepsicoLogo} alt='peplogo' />
                                    </span>
                                </Grid>
                                <Grid size={{ xs: 12, sm: 12 }} textAlign="center">
                                    <Button
                                        variant="contained"
                                        className={styles.submitBtn}
                                        style={buttonStyle}
                                        size="large"
                                        onClick={() => handleSSOExtSignIn()}
                                    >
                                        Supplier Login
                                    </Button>
                                </Grid>
                                <Grid size={{ xs: 12, sm: 12 }} textAlign="center">
                                    <Typography
                                        sx={{ font: 'normal normal bold 14px Segoe UI', color: '#384A9C', paddingTop: '15px', paddingBottom: '10px' }}>(or)</Typography>
                                </Grid>
                                <Grid size={{ xs: 12, sm: 12 }} textAlign="center">
                                    <button
                                        className={styles.textButton}
                                        onClick={() => handleSSOSignIn()}
                                    >
                                        Associate Login
                                    </button>
                                </Grid>
                                <Grid size={{ xs: 12, sm: 12 }} textAlign="center">
                                    <Typography sx={{ font: 'normal normal 14px Segoe UI', paddingTop: '20px' }}>
                                        First time user? Please click <button className={styles.textButton} onClick={handleRegistrationClick}>here</button>
                                    </Typography>
                                </Grid>
                            </Grid>
                        </form >
                    </Box>
                </Grid>
                <Grid size={{ xs: 2, sm: 3, md: 4, lg: 4, xl: 4.5 }}></Grid>
            </Grid>
        </div>
    )
}

export default LoginComponent;